(() => {
  'use strict';
  const header = document.querySelector('.shop-header');
  const toggle = header?.querySelector('.menu-toggle');
  const nav = header?.querySelector('#site-nav');
  const mobile = window.matchMedia('(max-width:760px)');
  const groups = [...document.querySelectorAll('.nav-group')];
  const closeGroups = except => groups.forEach(group => { if (group !== except) group.open = false; });
  let oldOverflow = '';
  const setMenu = (open, restoreFocus = false) => {
    if (!nav || !toggle) return;
    const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    nav.classList.toggle('is-open', open);
    if (open) {
      if (!wasOpen) oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      nav.style.setProperty('--mms-header-bottom', `${header.getBoundingClientRect().bottom}px`);
      nav.querySelector('[data-close-menu]')?.focus();
    } else {
      document.body.style.overflow = oldOverflow;
      closeGroups();
      if (restoreFocus) toggle.focus();
    }
  };
  toggle?.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
  nav?.querySelector('[data-close-menu]')?.addEventListener('click', () => setMenu(false, true));
  groups.forEach(group => {
    group.addEventListener('toggle', () => { if (group.open) closeGroups(group); });
    group.addEventListener('mouseenter', () => { if (!mobile.matches && matchMedia('(hover:hover)').matches) { closeGroups(group); group.open = true; } });
    group.addEventListener('mouseleave', () => { if (!mobile.matches && !group.contains(document.activeElement)) group.open = false; });
    group.addEventListener('focusout', () => setTimeout(() => { if (!mobile.matches && !group.contains(document.activeElement)) group.open = false; }, 0));
  });
  document.addEventListener('click', event => { if (!header?.contains(event.target)) closeGroups(); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const group = groups.find(item => item.open);
      if (group) { group.open = false; group.querySelector('summary').focus(); }
      else if (nav?.classList.contains('is-open')) setMenu(false, true);
    }
    if (event.key === 'Tab' && mobile.matches && nav?.classList.contains('is-open')) {
      const focusable = [toggle, ...nav.querySelectorAll('a,button,summary')].filter(el => el.getClientRects().length);
      const index = focusable.indexOf(document.activeElement);
      event.preventDefault();
      focusable[(index + (event.shiftKey ? -1 : 1) + focusable.length) % focusable.length]?.focus();
    }
  });
  mobile.addEventListener('change', () => setMenu(false));
  window.addEventListener('resize', () => { if (nav?.classList.contains('is-open')) nav.style.setProperty('--mms-header-bottom', `${header.getBoundingClientRect().bottom}px`); });
  document.querySelectorAll('[data-home-carousel]').forEach(carousel => {
    const slides = [...carousel.querySelectorAll('[data-slide]')];
    const dots = [...carousel.querySelectorAll('[data-slide-to]')];
    let index = 0;
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      carousel.querySelector('[data-slide-status]').textContent = `Featured collection ${index + 1} of ${slides.length}`;
    };
    show(index);
    carousel.querySelector('[data-slide-prev]')?.addEventListener('click', () => show(index - 1));
    carousel.querySelector('[data-slide-next]')?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    carousel.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); } });
    let start = null;
    carousel.addEventListener('touchstart', event => { start = {x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY}; }, {passive:true});
    carousel.addEventListener('touchend', event => {
      if (!start) return;
      const dx = event.changedTouches[0].clientX - start.x, dy = event.changedTouches[0].clientY - start.y;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));
      start = null;
    }, {passive:true});
  });
  document.querySelectorAll('[data-home-edits]').forEach(section => {
    const tabs = [...section.querySelectorAll('[data-edit-tab]')];
    const panels = [...section.querySelectorAll('[data-edit-panel]')];
    const select = (index, focus = false) => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      panels.forEach((panel, i) => {
        panel.hidden = i !== index;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabs[i].id);
        panel.tabIndex = 0;
      });
      if (focus) tabs[index].focus({preventScroll: true});
    };
    if (!tabs.length) return;
    section.querySelector('.home-edit-tabs').hidden = false;
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(next, true);
      });
    });
    select(0);
  });
})();
